<template>
  <div>
    <component v-bind:is="layout"></component>
  </div>
</template>

<script>
import "@/assets/styles.css"
import "@/assets/header.css"
import "@/assets/button.css"
import "@/assets/footer.css"
import "@/assets/table.css"
import "@/assets/form.css"
import "@/assets/badge.css"
import "@/assets/fonts/font-awesome/font-awesome.min.css"
import "remixicon/fonts/remixicon.css"

import config from "@/appConfig"
import router from "./router"
import axios from "axios"
// import { useRecaptchaProvider } from 'vue-recaptcha'
// import store from "./store";
import AppLayout from "./layouts/AppLayout"
import LoginLayout from "./layouts/LoginLayout"
import SdpiLayout from "./layouts/SdpiLayout"
import MetadataLayout from "./layouts/MetadataLayout"
import SdsLayout from "./layouts/SdsLayout"
import CmsLayout from "./layouts/CmsLayout"
import SshiLayout from "./layouts/SshiLayout"
import SshiLayoutBaru from "./layouts/Sshi2023Layout"
import PmseLayout from "./layouts/PmseLayout"
import MsLayout from "./layouts/MsLayout"
import SettingLayout from "./layouts/SettingLayout"
const defaultLayout = "app-layout"

axios.defaults.baseURL = config.BASE_API_URL

// useRecaptchaProvider()

export default {
  components: {
    "app-layout": AppLayout,
    "login-layout": LoginLayout,
    "sdpi-layout": SdpiLayout,
    "metadata-layout": MetadataLayout,
    "sds-layout": SdsLayout,
    "cms-layout": CmsLayout,
    "sshi-layout": SshiLayout,
    "sshi-layout-baru": SshiLayoutBaru,
    "pmse-layout": PmseLayout,
    "ms-layout": MsLayout,
    "setting-layout": SettingLayout,
  },
  mounted() {
    axios.interceptors.response.use(undefined, function(err) {
      return new Promise(function() {
        // if (err.response.data.status === 401) {
        //   store.dispatch("auth/logout").then(() => {
        //     window.location.replace(
        //       "https://sso.bps.go.id/auth/realms/pegawai-bps/protocol/openid-connect/logout" +
        //         "?&redirect_uri=" +
        //         window.location.protocol +
        //         "//" +
        //         window.location.host +
        //         process.env.VUE_APP_PUBLIC_PATH +
        //         "/login"
        //     );
        //     router.push("/");
        //   });
        // } else
        if (err.response.data.status === 403) {
          // router.match("/pmse/**") ? router.push("/pmse-forbidden") : router.push("/forbidden")
          router.push("/forbidden")
        }
        throw err
      })
    })
  },
  computed: {
    layout() {
      return this.$route.meta.layout || defaultLayout
    },
  },

  methods: {},
}
</script>


<style scoped>
@font-face {
  font-family: "Jakarta Plus";
  src: local("jakarta-plus"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-ExtraLight.woff)
      format("woff"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-ExtraLight.woff2)
      format("woff2");
  font-weight: 200;
}
@font-face {
  font-family: "Jakarta Plus";
  src: local("jakarta-plus"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-Light.woff)
      format("woff"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-Light.woff2)
      format("woff2");
  font-weight: 400;
}
@font-face {
  font-family: "Jakarta Plus";
  src: local("jakarta-plus"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-Regular.woff)
      format("woff"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-Regular.woff2)
      format("woff2");
  font-weight: 500;
}
@font-face {
  font-family: "Jakarta Plus";
  src: local("jakarta-plus"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-Medium.woff2)
      format("woff2");
  font-weight: 600;
}
@font-face {
  font-family: "Jakarta Plus";
  src: local("jakarta-plus"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-Bold.woff2)
      format("woff2");
  font-weight: 700;
}
@font-face {
  font-family: "Jakarta Plus";
  src: local("jakarta-plus"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-ExtraBold.woff)
      format("woff"),
    url(./assets/fonts/jakarta-plus/PlusJakartaSans-ExtraBold.woff2)
      format("woff2");
  font-weight: 800;
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 300;
  src: local("Open Sans Light"), local("OpenSans-Light"),
    url(./assets/fonts/open-sans/OpenSans-Light.ttf) format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 300;
  src: local("Open Sans Light Italic"), local("OpenSans-Light-Italic"),
    url(./assets/fonts/open-sans/OpenSans-LightItalic.ttf)
      format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  src: local("Open Sans Regular"), local("OpenSans-Regular"),
    url(./assets/fonts/open-sans/OpenSans-Regular.ttf) format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 400;
  src: local("Open Sans Italic"), local("OpenSans-Italic"),
    url(./assets/fonts/open-sans/OpenSans-Italic.ttf) format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  src: local("Open Sans Medium"), local("OpenSans-Medium"),
    url(./assets/fonts/open-sans/OpenSans-Medium.ttf) format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 500;
  src: local("Open Sans Medium Italic"), local("OpenSans-Medium-Italic"),
    url(./assets/fonts/open-sans/OpenSans-MediumItalic.ttf)
      format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  src: local("Open Sans SemiBold"), local("OpenSans-SemiBold"),
    url(./assets/fonts/open-sans/OpenSans-SemiBold.ttf) format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 600;
  src: local("Open Sans SemiBold Italic"),
    local("OpenSans-SemiBold-Italic"),
    url(./assets/fonts/open-sans/OpenSans-SemiBoldItalic.ttf)
      format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  src: local("Open Sans Bold"), local("OpenSans-Bold"),
    url(./assets/fonts/open-sans/OpenSans-Bold.ttf) format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 700;
  src: local("Open Sans Bold Italic"), local("OpenSans-Bold-Italic"),
    url(./assets/fonts/open-sans/OpenSans-BoldItalic.ttf)
      format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 800;
  src: local("Open Sans ExtraBold"), local("OpenSans-ExtraBold"),
    url(./assets/fonts/open-sans/OpenSans-ExtraBold.ttf) format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 800;
  src: local("Open Sans ExtraBold Italic"),
    local("OpenSans-ExtraBold-Italic"),
    url(./assets/fonts/open-sans/OpenSans-ExtraBoldItalic.ttf)
      format("truetype");
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 200;
  src: local("Manrope ExtraLight"), local("Manrope-ExtraBold"),
    url(./assets/fonts/manrope/Manrope-ExtraLight.ttf) format("truetype");
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 300;
  src: local("Manrope Light"), local("Manrope-Light"),
    url(./assets/fonts/manrope/Manrope-Light.ttf) format("truetype");
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  src: local("Manrope Regular"), local("Manrope-Regular"),
    url(./assets/fonts/manrope/Manrope-Regular.ttf) format("truetype");
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  src: local("Manrope Medium"), local("Manrope-Medium"),
    url(./assets/fonts/manrope/Manrope-Medium.ttf) format("truetype");
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 600;
  src: local("Manrope SemiBold"), local("Manrope-SemiBold"),
    url(./assets/fonts/manrope/Manrope-SemiBold.ttf) format("truetype");
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  src: local("Manrope Bold"), local("Manrope-Bold"),
    url(./assets/fonts/manrope/Manrope-Bold.ttf) format("truetype");
}

@font-face {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 800;
  src: local("Manrope ExtraBold"), local("Manrope-ExtraBold"),
    url(./assets/fonts/manrope/Manrope-ExtraBold.ttf) format("truetype");
}
</style>